// The measured height of the breadcrumb trail, shared between the component that
// renders it and the app bar that reserves room for it (issue #3210).
//
// Above WORKSPACE_DRAWER_BREAKPOINT the trail is pinned by rendering it into
// `v-app-bar`'s extension slot rather than by making it sticky itself. That is
// what keeps it out of the way of everything else anchored under the app bar -
// the workspace sidebar, the meeting section tabs, the voting banner, and
// anything added later - because Vuetify folds the extension's height into
// `--v-layout-top`, which every one of them already reads. A sticky element in
// `v-main` cannot do that: it would oblige each of them to subtract its height
// by hand, and nothing would catch the next one that forgets.
//
// Vuetify needs that height as a number (`extension-height`), so the component
// measures its own rendered trail and publishes it here. It is 0 on a route that
// renders no trail, which collapses the extension to nothing.

import { computed, ref, type ComputedRef } from "vue";

/** id of the container MainLayout renders inside `v-app-bar`'s extension slot. */
export const BREADCRUMB_EXTENSION_ID = "app-breadcrumbs-extension";

const measuredHeight = ref(0);

/** Called by AppBreadcrumbs whenever its rendered height changes (0 when absent). */
export function publishBreadcrumbSpineHeight(height: number): void {
  // Ceiling, not round: a fractional height rounded down leaves the app bar
  // reserving less room than the trail occupies, and the trail's last pixel row
  // overlaps the page.
  measuredHeight.value = Math.ceil(height);
}

export function useBreadcrumbSpineHeight(): { height: ComputedRef<number> } {
  return { height: computed(() => measuredHeight.value) };
}
